// extracted by mini-css-extract-plugin
export default {"deleteButtonContainer":"DeleteButton_deleteButtonContainer__6CGwO","deleteButton":"DeleteButton_deleteButton__SWIXg"};